import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page51() {
  useEffect(() => {
    document.title = "Маяк — Страница 50"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page49" />
        <ForwardLink href="/page51" />
      </div>

      <p style={{ textAlign: "right" }}>50.</p>
      <p>ОН В УЖАСЕ...</p>
      <p>И ЕЩЕ ОДНА ВОЛНА УДАРЯЕТ ЕГО...</p>
      <br/>
      <p>ВНУТРИ. ЗДАНИЕ ФОГОРНА – НОЧЬ</p>
      <p>
        РАКУРС НА: БАРОМЕТР. Стрелка падает. Она падает<br/>
        с “ДОЖДЬ” на “ШТОРМ.”
      </p>
      <p>МОЛОДОЙ снимает рубашку и разгребает уголь. Потный.</p>
      <p>
        У него в ушах куски тряпок, чтобы заглушить<br/>
        звук.
      </p>
      <p>ФОГОРН ревет.</p>
      <p>МОЛОДОЙ переводит дыхание. На его стуле стоит одна из БУТЫЛОК С ЛИКЕРОМ СТАРИКА.</p>
      <p>Он откупоривает бутылку с ликером. Нюхает ее.</p>
      <p>Он много думает о том, чтобы выпить.</p>
      <p>Нет.</p>
      <p>Закупоривает ее.</p>
      <p>Поджигает сигарету вместо это.</p>
      <p>МОЛОДОЙ поворачивается...</p>
      <p>СТАРИК стоит в дверном проеме, мокрый и обезумевший.</p>
      <p>
        МОЛОДОЙ хочет спросить, что случилось, но решает, что лучше<br/>
        не делать этого.
      </p>
      <p>МОЛОДОЙ почему-то чувствует себя слишком незащищенным без рубашки.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (кричит сквозь шум)<br/>
        СЫРОСТЬ ДОБРАЛАСЬ ДО ПРОВИЗИИ.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (кричит сквозь шум)<br/>
        ЧТО?
      </p>
      <p>МОЛОДОЙ вытаскивает обрывки ткани из ушей.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (кричит сквозь шум)<br/>
        СЫРОСТЬ ДОБРАЛАСЬ ДО ПРОВИЗИИ.
      </p>
      <p style={{ textAlign: "right" }}>50.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page49" />
        <ForwardLink href="/page51" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710335057/the-lighthouse-script/kjgkus29xad8hupg98xx.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page51;
